import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=guest, object=logged in

  useEffect(() => {
    api.get("/auth/me").then(({ data }) => setUser(data)).catch(() => {
      localStorage.removeItem("zk_token");
      setUser(false);
    });
  }, []);

  const logout = async () => {
    await api.post("/auth/logout");
    localStorage.removeItem("zk_token");
    setUser(false);
  };

  return <AuthContext.Provider value={{ user, setUser, logout }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
